import { DateTime } from 'luxon';
import { Diagnostic } from '../types/diagnostic';

export const ANNOTATION_TABLE_DEFAULT = '--';

export const diagnosticFactory = ({
  annotationTable = ANNOTATION_TABLE_DEFAULT,
  comment = '',
  expertName = '',
  expertRole = '',
  expertId = '',
  id = 123,
  abnormalities = [],
  updatedAt = DateTime.fromObject({ millisecond: 0 }).toUTC().toString(),
  pipeline = 'resting',
  suggestionsLogs = null,
}: Partial<Diagnostic> = {}): Diagnostic => ({
  annotationTable,
  comment,
  expertName,
  expertRole,
  expertId,
  id,
  abnormalities,
  updatedAt,
  pipeline,
  suggestionsLogs,
});
